import { inject, Injectable } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { filter, Subject, takeUntil } from 'rxjs';
import { Location } from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class UrlService {
    private _router: Router = inject(Router);
    private _location: Location = inject(Location);
    private _destroy$: Subject<void> = new Subject();
    private _backUrl: string | null = null;
    private _currentUrl: string = '';
    private _history: string[] = [];

    constructor() {
        this._currentUrl = this._router.url;
        this._router.events
            .pipe(
                takeUntil(this._destroy$),
                filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd)
            )
            .subscribe((event: NavigationEnd): void => {
                this._backUrl = this._currentUrl;
                this._currentUrl = event.url;
                this._history.push(event.urlAfterRedirects);
            });
    }

    // Returns previous url. If back url is equal current url returns null
    public getBackUrl(): string | null {
        return this._backUrl !== this._currentUrl ? this._backUrl : null;
    }

    async back(defaultUrl?: string): Promise<void> {
        this._history.pop();
        if (this._history.length > 0) {
            this._location.back();
        } else if (defaultUrl) {
            await this._router.navigateByUrl(defaultUrl);
        } else {
            await this._router.navigateByUrl('/');
        }
    }

    destroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }
}
